import React from "react";
import { Box, Typography } from "@material-ui/core";
import { FormattedHTMLMessage } from "react-intl";
import InfoIcon from "@material-ui/icons/Info";

const PermissionsInfo = ({ permissions, handleOpenDialog }) => {
  const { length } = permissions;
  const message = length === 0 ? "app.contractAgent.permissions.none" : length === 1 ? "app.contractAgent.permissions.one" : "app.contractAgent.permissions";
  return (
    <Box
      component={"span"}
      style={{
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        paddingRight: 4,
      }}
      onClick={() => handleOpenDialog()}
    >
      <Typography component={"span"}>
        <FormattedHTMLMessage
          id={message}
          values={{ value: length }}
        />
      </Typography>
      {length > 0 && <InfoIcon fontSize="small" />}
    </Box>
  );
};

export default PermissionsInfo;
